import React, { Component, PropTypes } from 'react';
import connect from 'connect-alt';

@connect('Advertisement')
class Outbrain extends Component {
    static propTypes = {
      AdvertisementStore: PropTypes.object.isRequired,
      FRN_page: PropTypes.object.isRequired,
      widgetId: PropTypes.string.isRequired,
      obTemplate: PropTypes.string.isRequired
    }

    static defaultProps = {
    }

    componentDidMount() {
      if (process.env.BROWSER) {
        const outbrain = window['outbrain'];

        if (!outbrain) {
          const $ = window['$'];

          $.getScript('https://widgets.outbrain.com/outbrain.js');
        }
      }
    }

    render() {
      const { 
        FRN_page: { uri = '' }, 
        widgetId, 
        obTemplate,
        AdvertisementStore: {
         showAds = true
       }
      } = this.props;

      if (!showAds || uri === '') {
        return null;
      }

      return (
          <div className="Outbrain">
            <div
              className="OUTBRAIN"
              data-src={uri}
              data-widget-id={widgetId}
              data-ob-template={obTemplate}
              />
          </div>
      );
    }
}

export default Outbrain;



// WEBPACK FOOTER //
// ./app/components/ads/Outbrain.js